export function richTextEditorDivClassWrapper(htmlString, className) {
  let _className = className ? className : '';

  return `<div class="ql-editor-custom ${_className}">${htmlString}</div>`;
}
